import { createContext } from "react"

//Types
import { SnackbarContextType } from "@/@types/ui/SnackbarContext";

const SnackbarContext = createContext<SnackbarContextType>({
  status: {show: false, message: "", variant: ""},
  showNotification: () => {},
  hideNotification: () => {}
});

SnackbarContext.displayName = "SnackbarContext";

export default SnackbarContext;
